import script from "./resetPasswordStep.vue?vue&type=script&setup=true&lang=ts"
export * from "./resetPasswordStep.vue?vue&type=script&setup=true&lang=ts"

import "./resetPasswordStep.vue?vue&type=style&index=0&id=3211ffb4&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3211ffb4"]])

export default __exports__